// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file websocket.proto (package com.gem.bff.contract, syntax proto3)

/* eslint-disable */
import type { Message } from '@bufbuild/protobuf';
import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';

import type {
  ChangeCompactRequest,
  CheckAuthorizationRequest,
  CreateCalendarEventRequest,
  DeleteCalendarEventRequest,
  DeleteRecurrenceEventRequest,
  GetCalendarAuthUrlRequest,
  GetCalendarEventRequest,
  GetCalendarEventsRequest,
  GetUserSettingsRequest,
  LogoutCalendarRequest,
  SaveCalendarCredentialRequest,
  SearchUsersAddToCalendarEventRequest,
  SubscribeToCalendarPushRequest,
  UnsubscribeToCalendarPushRequest,
  UpdateCalendarEventRequest,
  UpdateEventParticipantStatusRequest,
  UpdateRecurrenceCalendarEventRequest,
} from './calendar/event_request_pb';
import { file_calendar_event_request } from './calendar/event_request_pb';
import type {
  ChangeCompactResponse,
  CheckAuthorizationResponse,
  CreateCalendarEventResponse,
  DeleteCalendarEventResponse,
  DeleteRecurrenceCalendarEventResponse,
  GetCalendarAuthUrlResponse,
  GetCalendarEventResponse,
  GetCalendarEventsResponse,
  GetUserSettingsResponse,
  LogoutCalendarResponse,
  SaveCalendarCredentialResponse,
  SearchUsersAddToCalendarEventResponse,
  SubscribeToCalendarPushResponse,
  UnsubscribeToCalendarPushResponse,
  UpdateCalendarEventResponse,
  UpdateEventParticipantStatusResponse,
  UpdateRecurrenceCalendarEventResponse,
} from './calendar/event_response_pb';
import { file_calendar_event_response } from './calendar/event_response_pb';
import type {
  CreateCallRequest,
  CreateRoomRequest,
  DeclineCallRequest,
} from './call/call_requests_pb';
import { file_call_call_requests } from './call/call_requests_pb';
import type {
  CreateCallResponse,
  CreateRoomResponse,
  DeclineCallResponse,
} from './call/call_responses_pb';
import { file_call_call_responses } from './call/call_responses_pb';
import type {
  AcceptSecretChatAccessRequestsRequest,
  AddChatAdminsRequest,
  AddChatParticipantsRequest,
  AddSecretChatParticipantsRequest,
  ChatsByIdsRequest,
  ChatsPageRequest,
  ChatsUpdatesRequest,
  ClearChatHistoryForAllRequest,
  ClearChatHistoryForMeRequest,
  ConfirmReadChatMessagesRequest,
  CreateChatRequest,
  CreateE2eeCommitRequest,
  CreateSecretChatAccessRequestRequest,
  CreateSecretChatRequest,
  DeclineSecretChatAccessRequestsRequest,
  GetActiveSecretChatAccessRequestsRequest,
  GetChatUsersRequest,
  GetMultipleChatsEventsRequest,
  GetPinnedChatsRequest,
  GetUsersAddToChatRequest,
  JoinChatRequest,
  LeaveChatRequest,
  MarkChatsAsUnreadRequest,
  MuteChatRequest,
  PinChatRequest,
  PinMessagesRequest,
  RemoveChatParticipantsRequest,
  RemoveChatRequest,
  RemoveSecretChatParticipantsRequest,
  RevokeChatAdminsRequest,
  SearchUsersAddToChatRequest,
  SearchUsersForMentionRequest,
  SearchUsersInChatRequest,
  SetChatMessagesHistoryTtlRequest,
  TransferOwnershipRequest,
  UnpinAllMessagesRequest,
  UnpinChatRequest,
  UnpinMessagesRequest,
  UpdateChatRequest,
} from './chat/chat_requests_pb';
import { file_chat_chat_requests } from './chat/chat_requests_pb';
import type {
  AcceptSecretChatAccessRequestsResponse,
  AddChatAdminsResponse,
  AddChatParticipantsResponse,
  AddSecretChatParticipantsResponse,
  ChatsByIdsResponse,
  ChatsPageResponse,
  ChatsUpdatesResponse,
  ClearChatHistoryForAllResponse,
  ClearChatHistoryForMeResponse,
  ConfirmReadChatMessagesResponse,
  CreateChatResponse,
  CreateE2eeCommitResponse,
  CreateSecretChatAccessRequestResponse,
  CreateSecretChatResponse,
  DeclineSecretChatAccessRequestsResponse,
  GetActiveSecretChatAccessRequestsResponse,
  GetChatUsersResponse,
  GetMultipleChatsEventsResponse,
  GetPinnedChatsResponse,
  GetUsersAddToChatResponse,
  JoinChatResponse,
  LeaveChatResponse,
  MarkChatsAsUnreadResponse,
  MuteChatResponse,
  PinChatResponse,
  PinMessagesResponse,
  RemoveChatParticipantsResponse,
  RemoveChatResponse,
  RemoveSecretChatParticipantsResponse,
  RevokeChatAdminsResponse,
  SearchUsersAddToChatResponse,
  SearchUsersForMentionResponse,
  SearchUsersInChatResponse,
  SetChatMessagesHistoryTtlResponse,
  TransferOwnershipResponse,
  UnpinAllMessagesResponse,
  UnpinChatResponse,
  UnpinMessagesResponse,
  UpdateChatResponse,
} from './chat/chat_responses_pb';
import { file_chat_chat_responses } from './chat/chat_responses_pb';
import { file_common_common_responses } from './common/common_responses_pb';
import type {
  GetCalendarIntegrationEnabledRequest,
  GetE2eeIntegrationEnabledRequest,
} from './config/config_request_pb';
import { file_config_config_request } from './config/config_request_pb';
import type {
  GetCalendarIntegrationEnabledResponse,
  GetE2eeIntegrationEnabledResponse,
} from './config/config_response_pb';
import { file_config_config_response } from './config/config_response_pb';
import type {
  CreateMessageDeepLinkRequest,
  GetDeepLinkRequest,
  RefreshDeepLinkDetailsRequest,
} from './deeplink/deeplink_request_pb';
import { file_deeplink_deeplink_request } from './deeplink/deeplink_request_pb';
import type {
  CreateMessageDeepLinkResponse,
  GetDeepLinkResponse,
  RefreshDeepLinkDetailsResponse,
} from './deeplink/deeplink_response_pb';
import { file_deeplink_deeplink_response } from './deeplink/deeplink_response_pb';
import type {
  GetDevicesRequest,
  SetDeviceStatusRequest,
  TerminateDevicesRequest,
} from './device/device_request_pb';
import { file_device_device_request } from './device/device_request_pb';
import type {
  GetDevicesResponse,
  SetDeviceStatusResponse,
  TerminateDevicesResponse,
} from './device/device_response_pb';
import { file_device_device_response } from './device/device_response_pb';
import type {
  AckWelcomesRequest,
  ClearCurrentDeviceE2eeDataRequest,
  ConsumeKeyPackagesByUserIdAndDeviceIdRequest,
  ConsumeKeyPackagesByUserIdsRequest,
  GetCommitsRequest,
  GetKeyPackagesCountRequest,
  GetKeyPackagesForUntrustedDeviceRequest,
  GetWelcomesRequest,
  UploadKeyPackagesRequest,
} from './encryption/encryption_requests_pb';
import { file_encryption_encryption_requests } from './encryption/encryption_requests_pb';
import type {
  AckWelcomesResponse,
  ClearCurrentDeviceE2eeDataResponse,
  ConsumeKeyPackagesByUserIdAndDeviceIdResponse,
  ConsumeKeyPackagesByUserIdsResponse,
  GetCommitsResponse,
  GetKeyPackagesCountResponse,
  GetKeyPackagesForUntrustedDeviceResponse,
  GetWelcomesResponse,
  UploadKeyPackagesResponse,
} from './encryption/encryption_response_pb';
import { file_encryption_encryption_response } from './encryption/encryption_response_pb';
import type { CommonErrorResponse } from './error/error_responses_pb';
import { file_error_error_responses } from './error/error_responses_pb';
import type {
  AddMessageReactionRequest,
  DeleteMessagesRequest,
  DeleteScheduledMessagesRequest,
  ForwardMessagesRequest,
  GetLinkPreviewRequest,
  GetMessagesAroundTsRequest,
  GetMessagesByIdsRequest,
  GetMessagesByMediaTypesRequest,
  GetMessagesCountsRequest,
  GetMessagesRequest,
  GetRangeAroundMessageRequest,
  GetRangeAroundNextUserMentionRequest,
  GetScheduledMessagesByIdsRequest,
  GetScheduledMessagesRequest,
  GetUsersReactionsForMessageRequest,
  GetUsersViewedMessageRequest,
  IncreaseViewsRequest,
  RemoveMessageReactionRequest,
  ScheduleMessageRequest,
  SearchMessagesRequest,
  SendMessageRequest,
  SendScheduledMessageNowRequest,
  UpdateMessageRequest,
  UpdateScheduledMessageRequest,
} from './message/message_requests_pb';
import { file_message_message_requests } from './message/message_requests_pb';
import type {
  AddMessageReactionResponse,
  DeleteMessagesResponse,
  DeleteScheduledMessagesResponse,
  ForwardMessagesResponse,
  GetLinkPreviewResponse,
  GetMessagesAroundTsResponse,
  GetMessagesByIdsResponse,
  GetMessagesByMediaTypesResponse,
  GetMessagesCountsResponse,
  GetMessagesResponse,
  GetRangeAroundMessageResponse,
  GetRangeAroundNextUserMentionResponse,
  GetScheduledMessagesByIdsResponse,
  GetScheduledMessagesResponse,
  GetUsersReactionsForMessageResponse,
  GetUsersViewedMessageResponse,
  IncreaseViewsResponse,
  RemoveMessageReactionResponse,
  ScheduleMessageResponse,
  SearchMessagesResponse,
  SendMessageResponse,
  SendScheduledMessageNowResponse,
  UpdateMessageResponse,
  UpdateScheduledMessageResponse,
} from './message/message_responses_pb';
import { file_message_message_responses } from './message/message_responses_pb';
import type {
  RegisterPushTokenRequest,
  UnregisterPushTokensByDeviceIdRequest,
  UnregisterPushTokensRequest,
} from './notifications/notification_request_pb';
import { file_notifications_notification_request } from './notifications/notification_request_pb';
import type { PushTokenResponse } from './notifications/notification_response_pb';
import { file_notifications_notification_response } from './notifications/notification_response_pb';
import type { PingRequest } from './ping/ping_request_pb';
import { file_ping_ping_request } from './ping/ping_request_pb';
import type { PongResponse } from './ping/ping_response_pb';
import { file_ping_ping_response } from './ping/ping_response_pb';
import type { GetUserReactionsRequest } from './reaction/reaction_requests_pb';
import { file_reaction_reaction_requests } from './reaction/reaction_requests_pb';
import type { GetUserReactionsResponse } from './reaction/reaction_responses_pb';
import { file_reaction_reaction_responses } from './reaction/reaction_responses_pb';
import type {
  CalendarUpdateRealtimeEvent,
  CallIncomingRealtimeEvent,
  CallsActiveRealtimeEvent,
  CallSingleUpdateRealtimeEvent,
  ChatSingleUpdateRealtimeEvent,
  ChatStateChangedRealtimeEvent,
  ChatsUpdateRealtimeEvent,
  DeviceStatusUpdateEvent,
  MessageDeletedRealtimeEvent,
  MessageSentRealtimeEvent,
  MessagesUpdateRealtimeEvent,
  PushNotificationRealtimeEvent,
  SessionInvalidatedRealtimeEvent,
  UsersStatusUpdateRealtimeEvent,
  UserStatusSingleUpdateRealtimeEvent,
  UserTypingMessageRealtimeEvent,
} from './realtime_event/realtime_event_pb';
import { file_realtime_event_realtime_event } from './realtime_event/realtime_event_pb';
import type {
  RealtimeEventsSubscribeRequest,
  RealtimeSubscribeOnMessagesUpdateRequest,
  UserTypingMessageRequest,
} from './realtime_event/realtime_event_requests_pb';
import { file_realtime_event_realtime_event_requests } from './realtime_event/realtime_event_requests_pb';
import type {
  RealtimeEventsSubscribeResponse,
  RealtimeSubscribeOnMessagesUpdateResponse,
  UserTypingMessageResponse,
} from './realtime_event/realtime_event_responses_pb';
import { file_realtime_event_realtime_event_responses } from './realtime_event/realtime_event_responses_pb';
import type { GlobalSearchRequest } from './search/search_requests_pb';
import { file_search_search_requests } from './search/search_requests_pb';
import type { GlobalSearchResponse } from './search/search_responses_pb';
import { file_search_search_responses } from './search/search_responses_pb';
import type {
  AddStickerPackToProfileRequest,
  GetStickerPackByIdRequest,
  GetStickerPacksRequest,
  GetUserInstalledStickerPacksRequest,
  RemoveStickerPackFromProfileRequest,
} from './sticker/sticker_requests_pb';
import { file_sticker_sticker_requests } from './sticker/sticker_requests_pb';
import type {
  AddStickerPackToProfileResponse,
  GetStickerPackByIdResponse,
  GetStickerPacksResponse,
  GetUserInstalledStickerPacksResponse,
  RemoveStickerPackFromProfileResponse,
} from './sticker/sticker_responses_pb';
import { file_sticker_sticker_responses } from './sticker/sticker_responses_pb';
import type {
  GenerateUploadUrlRequest,
  GetStorageSessionRequest,
} from './upload/upload_requests_pb';
import { file_upload_upload_requests } from './upload/upload_requests_pb';
import type {
  GenerateUploadUrlResponse,
  GetStorageSessionResponse,
} from './upload/upload_responses_pb';
import { file_upload_upload_responses } from './upload/upload_responses_pb';
import type {
  GetSelfProfileRequest,
  GetUsersByEmailsRequest,
  UpdateProfileRequest,
  UsersByIdsRequest,
} from './user/user_requests_pb';
import { file_user_user_requests } from './user/user_requests_pb';
import type {
  GetSelfProfileResponse,
  GetUsersByEmailsResponse,
  UpdateProfileResponse,
  UsersByIdsResponse,
} from './user/user_responses_pb';
import { file_user_user_responses } from './user/user_responses_pb';
import type {
  GetWorkspaceRequest,
  GetWorkspaceUsersRequest,
  SearchUsersInWorkspaceRequest,
} from './workspace/workspace_requests_pb';
import { file_workspace_workspace_requests } from './workspace/workspace_requests_pb';
import type {
  GetWorkspaceResponse,
  GetWorkspaceUsersResponse,
  SearchUsersInWorkspaceResponse,
} from './workspace/workspace_responses_pb';
import { file_workspace_workspace_responses } from './workspace/workspace_responses_pb';

/**
 * Describes the file websocket.proto.
 */
export const file_websocket: GenFile =
  /*@__PURE__*/
  fileDesc(
    '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',
    [
      file_error_error_responses,
      file_common_common_responses,
      file_user_user_responses,
      file_user_user_requests,
      file_chat_chat_responses,
      file_chat_chat_requests,
      file_notifications_notification_request,
      file_notifications_notification_response,
      file_message_message_responses,
      file_message_message_requests,
      file_upload_upload_requests,
      file_upload_upload_responses,
      file_workspace_workspace_requests,
      file_workspace_workspace_responses,
      file_realtime_event_realtime_event,
      file_realtime_event_realtime_event_requests,
      file_realtime_event_realtime_event_responses,
      file_search_search_requests,
      file_search_search_responses,
      file_call_call_requests,
      file_call_call_responses,
      file_reaction_reaction_requests,
      file_reaction_reaction_responses,
      file_deeplink_deeplink_request,
      file_deeplink_deeplink_response,
      file_sticker_sticker_requests,
      file_sticker_sticker_responses,
      file_device_device_request,
      file_device_device_response,
      file_calendar_event_request,
      file_calendar_event_response,
      file_ping_ping_request,
      file_ping_ping_response,
      file_config_config_request,
      file_config_config_response,
      file_encryption_encryption_requests,
      file_encryption_encryption_response,
    ]
  );

/**
 * client -> server
 * /connect?token={access_token}
 * Example: ws://localhost:8080/connect?token=1234567890
 *
 * @generated from message com.gem.bff.contract.WsRequest
 */
export type WsRequest = Message<'com.gem.bff.contract.WsRequest'> & {
  /**
   * @generated from oneof com.gem.bff.contract.WsRequest.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.Request request = 1;
         */
        value: Request;
        case: 'request';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.WsRequest.
 * Use `create(WsRequestSchema)` to create a new message.
 */
export const WsRequestSchema: GenMessage<WsRequest> = /*@__PURE__*/ messageDesc(file_websocket, 0);

/**
 * server -> client
 *
 * @generated from message com.gem.bff.contract.WsResponse
 */
export type WsResponse = Message<'com.gem.bff.contract.WsResponse'> & {
  /**
   * @generated from oneof com.gem.bff.contract.WsResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.RealtimeEvent event = 1;
         */
        value: RealtimeEvent;
        case: 'event';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.Response response = 2;
         */
        value: Response;
        case: 'response';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.WsResponse.
 * Use `create(WsResponseSchema)` to create a new message.
 */
export const WsResponseSchema: GenMessage<WsResponse> =
  /*@__PURE__*/
  messageDesc(file_websocket, 1);

/**
 * @generated from message com.gem.bff.contract.Request
 */
export type Request = Message<'com.gem.bff.contract.Request'> & {
  /**
   * @generated from field: uint64 requestId = 1;
   */
  requestId: bigint;

  /**
   * @generated from oneof com.gem.bff.contract.Request.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatsPageRequest chatsPage = 2;
         */
        value: ChatsPageRequest;
        case: 'chatsPage';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatsByIdsRequest chatsByIds = 3;
         */
        value: ChatsByIdsRequest;
        case: 'chatsByIds';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.UsersByIdsRequest usersByIds = 4;
         */
        value: UsersByIdsRequest;
        case: 'usersByIds';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GenerateUploadUrlRequest generateUploadUrl = 5;
         */
        value: GenerateUploadUrlRequest;
        case: 'generateUploadUrl';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetSelfProfileRequest getSelfProfile = 6;
         */
        value: GetSelfProfileRequest;
        case: 'getSelfProfile';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.UpdateProfileRequest updateProfile = 7;
         */
        value: UpdateProfileRequest;
        case: 'updateProfile';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.CreateChatRequest createChat = 8;
         */
        value: CreateChatRequest;
        case: 'createChat';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.AddChatParticipantsRequest addChatParticipants = 9;
         */
        value: AddChatParticipantsRequest;
        case: 'addChatParticipants';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.AddChatAdminsRequest addChatAdmins = 10;
         */
        value: AddChatAdminsRequest;
        case: 'addChatAdmins';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.RemoveChatParticipantsRequest removeChatParticipants = 11;
         */
        value: RemoveChatParticipantsRequest;
        case: 'removeChatParticipants';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.RevokeChatAdminsRequest revokeChatAdmins = 12;
         */
        value: RevokeChatAdminsRequest;
        case: 'revokeChatAdmins';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.TransferOwnershipRequest transferOwnership = 13;
         */
        value: TransferOwnershipRequest;
        case: 'transferOwnership';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.LeaveChatRequest leaveChat = 14;
         */
        value: LeaveChatRequest;
        case: 'leaveChat';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.JoinChatRequest joinChat = 15;
         */
        value: JoinChatRequest;
        case: 'joinChat';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetMessagesRequest getMessages = 16;
         */
        value: GetMessagesRequest;
        case: 'getMessages';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetMessagesByMediaTypesRequest getMessagesByMediaTypes = 17;
         */
        value: GetMessagesByMediaTypesRequest;
        case: 'getMessagesByMediaTypes';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.UpdateMessageRequest updateMessage = 18;
         */
        value: UpdateMessageRequest;
        case: 'updateMessage';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.SendMessageRequest sendMessage = 19;
         */
        value: SendMessageRequest;
        case: 'sendMessage';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetRangeAroundMessageRequest getRangeAroundMessage = 20;
         */
        value: GetRangeAroundMessageRequest;
        case: 'getRangeAroundMessage';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetMessagesByIdsRequest getMessagesByIds = 21;
         */
        value: GetMessagesByIdsRequest;
        case: 'getMessagesByIds';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ForwardMessagesRequest forwardMessages = 22;
         */
        value: ForwardMessagesRequest;
        case: 'forwardMessages';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.DeleteMessagesRequest deleteMessages = 23;
         */
        value: DeleteMessagesRequest;
        case: 'deleteMessages';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ConfirmReadChatMessagesRequest confirmReadChatMessages = 24;
         */
        value: ConfirmReadChatMessagesRequest;
        case: 'confirmReadChatMessages';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.UnpinAllMessagesRequest unpinAllMessages = 25;
         */
        value: UnpinAllMessagesRequest;
        case: 'unpinAllMessages';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.UnpinMessagesRequest unpinMessages = 26;
         */
        value: UnpinMessagesRequest;
        case: 'unpinMessages';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.PinMessagesRequest pinMessages = 27;
         */
        value: PinMessagesRequest;
        case: 'pinMessages';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetPinnedChatsRequest getPinnedChats = 28;
         */
        value: GetPinnedChatsRequest;
        case: 'getPinnedChats';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.PinChatRequest pinChat = 29;
         */
        value: PinChatRequest;
        case: 'pinChat';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.UnpinChatRequest unpinChat = 30;
         */
        value: UnpinChatRequest;
        case: 'unpinChat';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ClearChatHistoryForMeRequest clearChatHistoryForMe = 31;
         */
        value: ClearChatHistoryForMeRequest;
        case: 'clearChatHistoryForMe';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ClearChatHistoryForAllRequest clearChatHistoryForAll = 32;
         */
        value: ClearChatHistoryForAllRequest;
        case: 'clearChatHistoryForAll';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.MuteChatRequest muteChat = 33;
         */
        value: MuteChatRequest;
        case: 'muteChat';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.UpdateChatRequest updateChat = 34;
         */
        value: UpdateChatRequest;
        case: 'updateChat';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.RemoveChatRequest removeChat = 35;
         */
        value: RemoveChatRequest;
        case: 'removeChat';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetWorkspaceRequest getWorkspace = 36;
         */
        value: GetWorkspaceRequest;
        case: 'getWorkspace';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetWorkspaceUsersRequest getWorkspaceUsers = 37;
         */
        value: GetWorkspaceUsersRequest;
        case: 'getWorkspaceUsers';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.SearchUsersInWorkspaceRequest searchUsersInWorkspace = 38;
         */
        value: SearchUsersInWorkspaceRequest;
        case: 'searchUsersInWorkspace';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.RealtimeEventsSubscribeRequest realtimeEventsSubscribe = 39;
         */
        value: RealtimeEventsSubscribeRequest;
        case: 'realtimeEventsSubscribe';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GlobalSearchRequest globalSearch = 40;
         */
        value: GlobalSearchRequest;
        case: 'globalSearch';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.SearchMessagesRequest searchMessages = 41;
         */
        value: SearchMessagesRequest;
        case: 'searchMessages';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetChatUsersRequest getChatUsers = 42;
         */
        value: GetChatUsersRequest;
        case: 'getChatUsers';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.SearchUsersAddToChatRequest searchUsersAddToChat = 43;
         */
        value: SearchUsersAddToChatRequest;
        case: 'searchUsersAddToChat';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.SearchUsersInChatRequest searchUsersInChat = 44;
         */
        value: SearchUsersInChatRequest;
        case: 'searchUsersInChat';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.SearchUsersForMentionRequest searchUsersForMention = 45;
         */
        value: SearchUsersForMentionRequest;
        case: 'searchUsersForMention';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.CreateCallRequest createCall = 46;
         */
        value: CreateCallRequest;
        case: 'createCall';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.DeclineCallRequest declineCall = 47;
         */
        value: DeclineCallRequest;
        case: 'declineCall';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.RegisterPushTokenRequest registerPushToken = 48;
         */
        value: RegisterPushTokenRequest;
        case: 'registerPushToken';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.UnregisterPushTokensRequest unregisterPushTokens = 49;
         */
        value: UnregisterPushTokensRequest;
        case: 'unregisterPushTokens';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetMessagesAroundTsRequest getRangeMessageByTs = 50;
         */
        value: GetMessagesAroundTsRequest;
        case: 'getRangeMessageByTs';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetRangeAroundNextUserMentionRequest getRangeAroundNextUserMention = 51;
         */
        value: GetRangeAroundNextUserMentionRequest;
        case: 'getRangeAroundNextUserMention';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetUsersReactionsForMessageRequest getUsersReactionsForMessage = 52;
         */
        value: GetUsersReactionsForMessageRequest;
        case: 'getUsersReactionsForMessage';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.AddMessageReactionRequest addMessageReaction = 53;
         */
        value: AddMessageReactionRequest;
        case: 'addMessageReaction';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.RemoveMessageReactionRequest removeMessageReaction = 54;
         */
        value: RemoveMessageReactionRequest;
        case: 'removeMessageReaction';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetUsersViewedMessageRequest getUsersViewedMessage = 55;
         */
        value: GetUsersViewedMessageRequest;
        case: 'getUsersViewedMessage';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.IncreaseViewsRequest increaseViews = 56;
         */
        value: IncreaseViewsRequest;
        case: 'increaseViews';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetMultipleChatsEventsRequest getMultipleChatsEvents = 57;
         */
        value: GetMultipleChatsEventsRequest;
        case: 'getMultipleChatsEvents';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatsUpdatesRequest chatsUpdates = 58;
         */
        value: ChatsUpdatesRequest;
        case: 'chatsUpdates';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.RealtimeSubscribeOnMessagesUpdateRequest subscribeOnMessages = 59;
         */
        value: RealtimeSubscribeOnMessagesUpdateRequest;
        case: 'subscribeOnMessages';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.UnregisterPushTokensByDeviceIdRequest unregisterPushTokensByDeviceId = 60;
         */
        value: UnregisterPushTokensByDeviceIdRequest;
        case: 'unregisterPushTokensByDeviceId';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetUsersAddToChatRequest getUsersAddToChat = 61;
         */
        value: GetUsersAddToChatRequest;
        case: 'getUsersAddToChat';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetUserReactionsRequest getUserReactions = 62;
         */
        value: GetUserReactionsRequest;
        case: 'getUserReactions';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetLinkPreviewRequest getLinkPreview = 63;
         */
        value: GetLinkPreviewRequest;
        case: 'getLinkPreview';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetDeepLinkRequest getDeepLink = 64;
         */
        value: GetDeepLinkRequest;
        case: 'getDeepLink';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.RefreshDeepLinkDetailsRequest refreshDeepLinkDetails = 65;
         */
        value: RefreshDeepLinkDetailsRequest;
        case: 'refreshDeepLinkDetails';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.CreateMessageDeepLinkRequest createMessageDeepLink = 67;
         */
        value: CreateMessageDeepLinkRequest;
        case: 'createMessageDeepLink';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetStickerPacksRequest getStickerPacks = 68;
         */
        value: GetStickerPacksRequest;
        case: 'getStickerPacks';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetUserInstalledStickerPacksRequest getUserInstalledStickerPacks = 69;
         */
        value: GetUserInstalledStickerPacksRequest;
        case: 'getUserInstalledStickerPacks';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetStickerPackByIdRequest getStickerPackById = 70;
         */
        value: GetStickerPackByIdRequest;
        case: 'getStickerPackById';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.AddStickerPackToProfileRequest addStickerPackToProfile = 71;
         */
        value: AddStickerPackToProfileRequest;
        case: 'addStickerPackToProfile';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.RemoveStickerPackFromProfileRequest removeStickerPackFromProfile = 72;
         */
        value: RemoveStickerPackFromProfileRequest;
        case: 'removeStickerPackFromProfile';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetMessagesCountsRequest getMessagesCounts = 74;
         */
        value: GetMessagesCountsRequest;
        case: 'getMessagesCounts';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.UserTypingMessageRequest userTypingMessage = 75;
         */
        value: UserTypingMessageRequest;
        case: 'userTypingMessage';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.CreateRoomRequest createRoom = 76;
         */
        value: CreateRoomRequest;
        case: 'createRoom';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetDevicesRequest getDevices = 79;
         */
        value: GetDevicesRequest;
        case: 'getDevices';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.TerminateDevicesRequest terminateDevices = 80;
         */
        value: TerminateDevicesRequest;
        case: 'terminateDevices';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.CreateCalendarEventRequest createCalendarEvent = 81;
         */
        value: CreateCalendarEventRequest;
        case: 'createCalendarEvent';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetCalendarEventRequest getCalendarEvent = 82;
         */
        value: GetCalendarEventRequest;
        case: 'getCalendarEvent';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetCalendarEventsRequest getCalendarEvents = 83;
         */
        value: GetCalendarEventsRequest;
        case: 'getCalendarEvents';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.UpdateCalendarEventRequest updateCalendarEvent = 84;
         */
        value: UpdateCalendarEventRequest;
        case: 'updateCalendarEvent';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.DeleteCalendarEventRequest deleteCalendarEvent = 85;
         */
        value: DeleteCalendarEventRequest;
        case: 'deleteCalendarEvent';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.SubscribeToCalendarPushRequest subscribeToPush = 86;
         */
        value: SubscribeToCalendarPushRequest;
        case: 'subscribeToPush';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.DeleteRecurrenceEventRequest deleteRecurrenceEvent = 87;
         */
        value: DeleteRecurrenceEventRequest;
        case: 'deleteRecurrenceEvent';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.UpdateRecurrenceCalendarEventRequest updateRecurrenceEvent = 89;
         */
        value: UpdateRecurrenceCalendarEventRequest;
        case: 'updateRecurrenceEvent';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.SaveCalendarCredentialRequest saveCalendarCredential = 90;
         */
        value: SaveCalendarCredentialRequest;
        case: 'saveCalendarCredential';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetUsersByEmailsRequest getUsersByEmails = 91;
         */
        value: GetUsersByEmailsRequest;
        case: 'getUsersByEmails';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.LogoutCalendarRequest logout = 92;
         */
        value: LogoutCalendarRequest;
        case: 'logout';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.CheckAuthorizationRequest checkAuthorization = 93;
         */
        value: CheckAuthorizationRequest;
        case: 'checkAuthorization';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.UpdateEventParticipantStatusRequest updateEventParticipantStatus = 94;
         */
        value: UpdateEventParticipantStatusRequest;
        case: 'updateEventParticipantStatus';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetUserSettingsRequest getUserSettings = 95;
         */
        value: GetUserSettingsRequest;
        case: 'getUserSettings';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChangeCompactRequest changeCompact = 96;
         */
        value: ChangeCompactRequest;
        case: 'changeCompact';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.SearchUsersAddToCalendarEventRequest searchUsersAddToCalendarEvent = 97;
         */
        value: SearchUsersAddToCalendarEventRequest;
        case: 'searchUsersAddToCalendarEvent';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.PingRequest ping = 98;
         */
        value: PingRequest;
        case: 'ping';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetCalendarIntegrationEnabledRequest getCalendarIntegrationEnabled = 99;
         */
        value: GetCalendarIntegrationEnabledRequest;
        case: 'getCalendarIntegrationEnabled';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.UnsubscribeToCalendarPushRequest unsubscribeToPushRequest = 100;
         */
        value: UnsubscribeToCalendarPushRequest;
        case: 'unsubscribeToPushRequest';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetCalendarAuthUrlRequest getCalendarUrl = 101;
         */
        value: GetCalendarAuthUrlRequest;
        case: 'getCalendarUrl';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.MarkChatsAsUnreadRequest markChatsAsUnread = 102;
         */
        value: MarkChatsAsUnreadRequest;
        case: 'markChatsAsUnread';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.UploadKeyPackagesRequest uploadKeyPackages = 103;
         */
        value: UploadKeyPackagesRequest;
        case: 'uploadKeyPackages';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ConsumeKeyPackagesByUserIdsRequest consumeKeyPackagesByUserIds = 104;
         */
        value: ConsumeKeyPackagesByUserIdsRequest;
        case: 'consumeKeyPackagesByUserIds';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.CreateSecretChatRequest createSecretChat = 105;
         */
        value: CreateSecretChatRequest;
        case: 'createSecretChat';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.AddSecretChatParticipantsRequest addSecretChatParticipants = 106;
         */
        value: AddSecretChatParticipantsRequest;
        case: 'addSecretChatParticipants';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.RemoveSecretChatParticipantsRequest removeSecretChatParticipants = 107;
         */
        value: RemoveSecretChatParticipantsRequest;
        case: 'removeSecretChatParticipants';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetCommitsRequest getCommits = 108;
         */
        value: GetCommitsRequest;
        case: 'getCommits';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetWelcomesRequest getWelcomes = 109;
         */
        value: GetWelcomesRequest;
        case: 'getWelcomes';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.AckWelcomesRequest ackWelcomes = 110;
         */
        value: AckWelcomesRequest;
        case: 'ackWelcomes';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetE2eeIntegrationEnabledRequest getE2eeIntegrationEnabled = 111;
         */
        value: GetE2eeIntegrationEnabledRequest;
        case: 'getE2eeIntegrationEnabled';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ScheduleMessageRequest scheduleMessage = 112;
         */
        value: ScheduleMessageRequest;
        case: 'scheduleMessage';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.SendScheduledMessageNowRequest sendScheduledMessageNow = 113;
         */
        value: SendScheduledMessageNowRequest;
        case: 'sendScheduledMessageNow';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.UpdateScheduledMessageRequest updateScheduledMessage = 114;
         */
        value: UpdateScheduledMessageRequest;
        case: 'updateScheduledMessage';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.DeleteScheduledMessagesRequest deleteScheduledMessages = 115;
         */
        value: DeleteScheduledMessagesRequest;
        case: 'deleteScheduledMessages';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetScheduledMessagesRequest getScheduledMessages = 116;
         */
        value: GetScheduledMessagesRequest;
        case: 'getScheduledMessages';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetScheduledMessagesByIdsRequest getScheduledMessagesByIds = 117;
         */
        value: GetScheduledMessagesByIdsRequest;
        case: 'getScheduledMessagesByIds';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetStorageSessionRequest getStorageSession = 118;
         */
        value: GetStorageSessionRequest;
        case: 'getStorageSession';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.SetChatMessagesHistoryTtlRequest setChatMessagesHistoryTtl = 119;
         */
        value: SetChatMessagesHistoryTtlRequest;
        case: 'setChatMessagesHistoryTtl';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetKeyPackagesForUntrustedDeviceRequest getKeyPackagesForUntrustedDevice = 120;
         */
        value: GetKeyPackagesForUntrustedDeviceRequest;
        case: 'getKeyPackagesForUntrustedDevice';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.CreateSecretChatAccessRequestRequest createSecretChatAccessRequest = 121;
         */
        value: CreateSecretChatAccessRequestRequest;
        case: 'createSecretChatAccessRequest';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetActiveSecretChatAccessRequestsRequest getActiveSecretChatAccessRequests = 122;
         */
        value: GetActiveSecretChatAccessRequestsRequest;
        case: 'getActiveSecretChatAccessRequests';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.AcceptSecretChatAccessRequestsRequest acceptSecretChatAccessRequests = 123;
         */
        value: AcceptSecretChatAccessRequestsRequest;
        case: 'acceptSecretChatAccessRequests';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.DeclineSecretChatAccessRequestsRequest declineSecretChatAccessRequests = 124;
         */
        value: DeclineSecretChatAccessRequestsRequest;
        case: 'declineSecretChatAccessRequests';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.CreateE2eeCommitRequest createE2eeCommit = 125;
         */
        value: CreateE2eeCommitRequest;
        case: 'createE2eeCommit';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ConsumeKeyPackagesByUserIdAndDeviceIdRequest consumeKeyPackagesByUserIdAndDeviceId = 126;
         */
        value: ConsumeKeyPackagesByUserIdAndDeviceIdRequest;
        case: 'consumeKeyPackagesByUserIdAndDeviceId';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.SetDeviceStatusRequest setDeviceStatus = 127;
         */
        value: SetDeviceStatusRequest;
        case: 'setDeviceStatus';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ClearCurrentDeviceE2eeDataRequest clearCurrentDeviceE2eeData = 128;
         */
        value: ClearCurrentDeviceE2eeDataRequest;
        case: 'clearCurrentDeviceE2eeData';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetKeyPackagesCountRequest getKeyPackagesCount = 129;
         */
        value: GetKeyPackagesCountRequest;
        case: 'getKeyPackagesCount';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.Request.
 * Use `create(RequestSchema)` to create a new message.
 */
export const RequestSchema: GenMessage<Request> = /*@__PURE__*/ messageDesc(file_websocket, 2);

/**
 * @generated from message com.gem.bff.contract.Response
 */
export type Response = Message<'com.gem.bff.contract.Response'> & {
  /**
   * @generated from field: uint64 requestId = 1;
   */
  requestId: bigint;

  /**
   * @generated from field: string traceId = 75;
   */
  traceId: string;

  /**
   * @generated from oneof com.gem.bff.contract.Response.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.CommonErrorResponse error = 2;
         */
        value: CommonErrorResponse;
        case: 'error';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatsPageResponse chatsPage = 3;
         */
        value: ChatsPageResponse;
        case: 'chatsPage';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatsByIdsResponse chatsByIds = 4;
         */
        value: ChatsByIdsResponse;
        case: 'chatsByIds';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.UsersByIdsResponse usersByIds = 5;
         */
        value: UsersByIdsResponse;
        case: 'usersByIds';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GenerateUploadUrlResponse generateUploadUrl = 6;
         */
        value: GenerateUploadUrlResponse;
        case: 'generateUploadUrl';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetSelfProfileResponse getSelfProfile = 7;
         */
        value: GetSelfProfileResponse;
        case: 'getSelfProfile';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.UpdateProfileResponse updateProfile = 8;
         */
        value: UpdateProfileResponse;
        case: 'updateProfile';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.CreateChatResponse createChat = 9;
         */
        value: CreateChatResponse;
        case: 'createChat';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.AddChatParticipantsResponse addChatParticipants = 10;
         */
        value: AddChatParticipantsResponse;
        case: 'addChatParticipants';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.AddChatAdminsResponse addChatAdmins = 11;
         */
        value: AddChatAdminsResponse;
        case: 'addChatAdmins';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.RemoveChatParticipantsResponse removeChatParticipants = 12;
         */
        value: RemoveChatParticipantsResponse;
        case: 'removeChatParticipants';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.RevokeChatAdminsResponse revokeChatAdmins = 13;
         */
        value: RevokeChatAdminsResponse;
        case: 'revokeChatAdmins';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.TransferOwnershipResponse transferOwnership = 14;
         */
        value: TransferOwnershipResponse;
        case: 'transferOwnership';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.LeaveChatResponse leaveChat = 15;
         */
        value: LeaveChatResponse;
        case: 'leaveChat';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.JoinChatResponse joinChat = 16;
         */
        value: JoinChatResponse;
        case: 'joinChat';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetMessagesResponse getMessages = 17;
         */
        value: GetMessagesResponse;
        case: 'getMessages';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetMessagesByMediaTypesResponse getMessagesByMediaTypes = 18;
         */
        value: GetMessagesByMediaTypesResponse;
        case: 'getMessagesByMediaTypes';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.UpdateMessageResponse updateMessage = 19;
         */
        value: UpdateMessageResponse;
        case: 'updateMessage';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.SendMessageResponse sendMessage = 20;
         */
        value: SendMessageResponse;
        case: 'sendMessage';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetRangeAroundMessageResponse getRangeAroundMessage = 21;
         */
        value: GetRangeAroundMessageResponse;
        case: 'getRangeAroundMessage';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetMessagesByIdsResponse getMessagesByIds = 22;
         */
        value: GetMessagesByIdsResponse;
        case: 'getMessagesByIds';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ForwardMessagesResponse forwardMessages = 23;
         */
        value: ForwardMessagesResponse;
        case: 'forwardMessages';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.DeleteMessagesResponse deleteMessages = 24;
         */
        value: DeleteMessagesResponse;
        case: 'deleteMessages';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ConfirmReadChatMessagesResponse confirmReadChatMessages = 25;
         */
        value: ConfirmReadChatMessagesResponse;
        case: 'confirmReadChatMessages';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.UnpinAllMessagesResponse unpinAllMessages = 26;
         */
        value: UnpinAllMessagesResponse;
        case: 'unpinAllMessages';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.UnpinMessagesResponse unpinMessages = 27;
         */
        value: UnpinMessagesResponse;
        case: 'unpinMessages';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.PinMessagesResponse pinMessages = 28;
         */
        value: PinMessagesResponse;
        case: 'pinMessages';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetPinnedChatsResponse getPinnedChats = 29;
         */
        value: GetPinnedChatsResponse;
        case: 'getPinnedChats';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.PinChatResponse pinChat = 30;
         */
        value: PinChatResponse;
        case: 'pinChat';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.UnpinChatResponse unpinChat = 31;
         */
        value: UnpinChatResponse;
        case: 'unpinChat';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ClearChatHistoryForMeResponse clearChatHistoryForMe = 32;
         */
        value: ClearChatHistoryForMeResponse;
        case: 'clearChatHistoryForMe';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ClearChatHistoryForAllResponse clearChatHistoryForAll = 33;
         */
        value: ClearChatHistoryForAllResponse;
        case: 'clearChatHistoryForAll';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.MuteChatResponse muteChat = 34;
         */
        value: MuteChatResponse;
        case: 'muteChat';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.UpdateChatResponse updateChat = 35;
         */
        value: UpdateChatResponse;
        case: 'updateChat';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.RemoveChatResponse removeChat = 36;
         */
        value: RemoveChatResponse;
        case: 'removeChat';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetWorkspaceResponse getWorkspace = 37;
         */
        value: GetWorkspaceResponse;
        case: 'getWorkspace';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetWorkspaceUsersResponse getWorkspaceUsers = 38;
         */
        value: GetWorkspaceUsersResponse;
        case: 'getWorkspaceUsers';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.SearchUsersInWorkspaceResponse searchUsersInWorkspace = 39;
         */
        value: SearchUsersInWorkspaceResponse;
        case: 'searchUsersInWorkspace';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.RealtimeEventsSubscribeResponse realtimeEventsSubscribe = 40;
         */
        value: RealtimeEventsSubscribeResponse;
        case: 'realtimeEventsSubscribe';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GlobalSearchResponse globalSearch = 41;
         */
        value: GlobalSearchResponse;
        case: 'globalSearch';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.SearchMessagesResponse searchMessages = 42;
         */
        value: SearchMessagesResponse;
        case: 'searchMessages';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetChatUsersResponse getChatUsers = 43;
         */
        value: GetChatUsersResponse;
        case: 'getChatUsers';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.SearchUsersAddToChatResponse searchUsersAddToChat = 44;
         */
        value: SearchUsersAddToChatResponse;
        case: 'searchUsersAddToChat';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.SearchUsersInChatResponse searchUsersInChat = 45;
         */
        value: SearchUsersInChatResponse;
        case: 'searchUsersInChat';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.SearchUsersForMentionResponse searchUsersForMention = 46;
         */
        value: SearchUsersForMentionResponse;
        case: 'searchUsersForMention';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.CreateCallResponse createCall = 47;
         */
        value: CreateCallResponse;
        case: 'createCall';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.DeclineCallResponse declineCall = 48;
         */
        value: DeclineCallResponse;
        case: 'declineCall';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.PushTokenResponse pushToken = 49;
         */
        value: PushTokenResponse;
        case: 'pushToken';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetMessagesAroundTsResponse getRangeMessageByTs = 50;
         */
        value: GetMessagesAroundTsResponse;
        case: 'getRangeMessageByTs';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetRangeAroundNextUserMentionResponse getRangeAroundNextUserMention = 51;
         */
        value: GetRangeAroundNextUserMentionResponse;
        case: 'getRangeAroundNextUserMention';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetUsersReactionsForMessageResponse getUsersReactionsForMessage = 52;
         */
        value: GetUsersReactionsForMessageResponse;
        case: 'getUsersReactionsForMessage';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.AddMessageReactionResponse addMessageReaction = 53;
         */
        value: AddMessageReactionResponse;
        case: 'addMessageReaction';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.RemoveMessageReactionResponse removeMessageReaction = 54;
         */
        value: RemoveMessageReactionResponse;
        case: 'removeMessageReaction';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetUsersViewedMessageResponse getUsersViewedMessage = 55;
         */
        value: GetUsersViewedMessageResponse;
        case: 'getUsersViewedMessage';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.IncreaseViewsResponse increaseViews = 56;
         */
        value: IncreaseViewsResponse;
        case: 'increaseViews';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetMultipleChatsEventsResponse getMultipleChatsEvents = 57;
         */
        value: GetMultipleChatsEventsResponse;
        case: 'getMultipleChatsEvents';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatsUpdatesResponse chatsUpdates = 58;
         */
        value: ChatsUpdatesResponse;
        case: 'chatsUpdates';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.RealtimeSubscribeOnMessagesUpdateResponse subscribeOnMessages = 59;
         */
        value: RealtimeSubscribeOnMessagesUpdateResponse;
        case: 'subscribeOnMessages';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetUsersAddToChatResponse getUsersAddToChat = 60;
         */
        value: GetUsersAddToChatResponse;
        case: 'getUsersAddToChat';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetUserReactionsResponse getUserReactions = 61;
         */
        value: GetUserReactionsResponse;
        case: 'getUserReactions';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetLinkPreviewResponse getLinkPreview = 62;
         */
        value: GetLinkPreviewResponse;
        case: 'getLinkPreview';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetDeepLinkResponse getDeepLink = 63;
         */
        value: GetDeepLinkResponse;
        case: 'getDeepLink';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.RefreshDeepLinkDetailsResponse refreshDeepLinkDetails = 64;
         */
        value: RefreshDeepLinkDetailsResponse;
        case: 'refreshDeepLinkDetails';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.CreateMessageDeepLinkResponse createMessageDeepLink = 66;
         */
        value: CreateMessageDeepLinkResponse;
        case: 'createMessageDeepLink';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetStickerPacksResponse getStickerPacks = 67;
         */
        value: GetStickerPacksResponse;
        case: 'getStickerPacks';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetUserInstalledStickerPacksResponse getUserInstalledStickerPacks = 68;
         */
        value: GetUserInstalledStickerPacksResponse;
        case: 'getUserInstalledStickerPacks';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetStickerPackByIdResponse getStickerPackById = 69;
         */
        value: GetStickerPackByIdResponse;
        case: 'getStickerPackById';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.AddStickerPackToProfileResponse addStickerPackToProfile = 70;
         */
        value: AddStickerPackToProfileResponse;
        case: 'addStickerPackToProfile';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.RemoveStickerPackFromProfileResponse removeStickerPackFromProfile = 71;
         */
        value: RemoveStickerPackFromProfileResponse;
        case: 'removeStickerPackFromProfile';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetMessagesCountsResponse getMessagesCounts = 73;
         */
        value: GetMessagesCountsResponse;
        case: 'getMessagesCounts';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.UserTypingMessageResponse userTypingMessage = 74;
         */
        value: UserTypingMessageResponse;
        case: 'userTypingMessage';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.CreateRoomResponse createRoom = 76;
         */
        value: CreateRoomResponse;
        case: 'createRoom';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetDevicesResponse getDevices = 78;
         */
        value: GetDevicesResponse;
        case: 'getDevices';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.TerminateDevicesResponse terminateDevice = 79;
         */
        value: TerminateDevicesResponse;
        case: 'terminateDevice';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.CreateCalendarEventResponse createCalendarEvent = 80;
         */
        value: CreateCalendarEventResponse;
        case: 'createCalendarEvent';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetCalendarEventResponse getCalendarEvent = 81;
         */
        value: GetCalendarEventResponse;
        case: 'getCalendarEvent';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.UpdateCalendarEventResponse updateCalendarEvent = 82;
         */
        value: UpdateCalendarEventResponse;
        case: 'updateCalendarEvent';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.DeleteCalendarEventResponse deleteCalendarEvent = 83;
         */
        value: DeleteCalendarEventResponse;
        case: 'deleteCalendarEvent';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetCalendarEventsResponse getCalendarEvents = 84;
         */
        value: GetCalendarEventsResponse;
        case: 'getCalendarEvents';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.DeleteRecurrenceCalendarEventResponse deleteRecurrenceCalendarEvent = 85;
         */
        value: DeleteRecurrenceCalendarEventResponse;
        case: 'deleteRecurrenceCalendarEvent';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.SubscribeToCalendarPushResponse subscribeToPush = 86;
         */
        value: SubscribeToCalendarPushResponse;
        case: 'subscribeToPush';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.UpdateRecurrenceCalendarEventResponse updateRecurrenceCalendarEvent = 88;
         */
        value: UpdateRecurrenceCalendarEventResponse;
        case: 'updateRecurrenceCalendarEvent';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.SaveCalendarCredentialResponse saveCalendarCredential = 89;
         */
        value: SaveCalendarCredentialResponse;
        case: 'saveCalendarCredential';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetUsersByEmailsResponse getUsersByEmails = 90;
         */
        value: GetUsersByEmailsResponse;
        case: 'getUsersByEmails';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.LogoutCalendarResponse logout = 91;
         */
        value: LogoutCalendarResponse;
        case: 'logout';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.CheckAuthorizationResponse checkAuthorization = 92;
         */
        value: CheckAuthorizationResponse;
        case: 'checkAuthorization';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.UpdateEventParticipantStatusResponse updateEventParticipantStatus = 93;
         */
        value: UpdateEventParticipantStatusResponse;
        case: 'updateEventParticipantStatus';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetUserSettingsResponse getUserSettings = 94;
         */
        value: GetUserSettingsResponse;
        case: 'getUserSettings';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChangeCompactResponse changeCompact = 95;
         */
        value: ChangeCompactResponse;
        case: 'changeCompact';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.SearchUsersAddToCalendarEventResponse searchUsersAddToCalendarEvent = 96;
         */
        value: SearchUsersAddToCalendarEventResponse;
        case: 'searchUsersAddToCalendarEvent';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.PongResponse pong = 97;
         */
        value: PongResponse;
        case: 'pong';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetCalendarIntegrationEnabledResponse getCalendarIntegrationEnabled = 98;
         */
        value: GetCalendarIntegrationEnabledResponse;
        case: 'getCalendarIntegrationEnabled';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.UnsubscribeToCalendarPushResponse unsubscribeToPushResponse = 99;
         */
        value: UnsubscribeToCalendarPushResponse;
        case: 'unsubscribeToPushResponse';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetCalendarAuthUrlResponse getCalendarAuthUrl = 100;
         */
        value: GetCalendarAuthUrlResponse;
        case: 'getCalendarAuthUrl';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.MarkChatsAsUnreadResponse markChatsAsUnread = 102;
         */
        value: MarkChatsAsUnreadResponse;
        case: 'markChatsAsUnread';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.UploadKeyPackagesResponse uploadKeyPackages = 103;
         */
        value: UploadKeyPackagesResponse;
        case: 'uploadKeyPackages';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ConsumeKeyPackagesByUserIdsResponse consumeKeyPackagesByUserIds = 104;
         */
        value: ConsumeKeyPackagesByUserIdsResponse;
        case: 'consumeKeyPackagesByUserIds';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.CreateSecretChatResponse createSecretChat = 105;
         */
        value: CreateSecretChatResponse;
        case: 'createSecretChat';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.AddSecretChatParticipantsResponse addSecretChatParticipants = 106;
         */
        value: AddSecretChatParticipantsResponse;
        case: 'addSecretChatParticipants';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.RemoveSecretChatParticipantsResponse removeSecretChatParticipants = 107;
         */
        value: RemoveSecretChatParticipantsResponse;
        case: 'removeSecretChatParticipants';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetCommitsResponse getCommits = 108;
         */
        value: GetCommitsResponse;
        case: 'getCommits';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetWelcomesResponse getWelcomes = 109;
         */
        value: GetWelcomesResponse;
        case: 'getWelcomes';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.AckWelcomesResponse ackWelcomes = 110;
         */
        value: AckWelcomesResponse;
        case: 'ackWelcomes';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetE2eeIntegrationEnabledResponse getE2eeIntegrationEnabled = 111;
         */
        value: GetE2eeIntegrationEnabledResponse;
        case: 'getE2eeIntegrationEnabled';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ScheduleMessageResponse scheduleMessage = 112;
         */
        value: ScheduleMessageResponse;
        case: 'scheduleMessage';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.SendScheduledMessageNowResponse sendScheduledMessageNow = 113;
         */
        value: SendScheduledMessageNowResponse;
        case: 'sendScheduledMessageNow';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.UpdateScheduledMessageResponse updateScheduledMessage = 114;
         */
        value: UpdateScheduledMessageResponse;
        case: 'updateScheduledMessage';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.DeleteScheduledMessagesResponse deleteScheduledMessages = 115;
         */
        value: DeleteScheduledMessagesResponse;
        case: 'deleteScheduledMessages';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetScheduledMessagesResponse getScheduledMessages = 116;
         */
        value: GetScheduledMessagesResponse;
        case: 'getScheduledMessages';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetScheduledMessagesByIdsResponse getScheduledMessagesByIds = 117;
         */
        value: GetScheduledMessagesByIdsResponse;
        case: 'getScheduledMessagesByIds';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetStorageSessionResponse getStorageSession = 118;
         */
        value: GetStorageSessionResponse;
        case: 'getStorageSession';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.SetChatMessagesHistoryTtlResponse setChatMessagesHistoryTtl = 119;
         */
        value: SetChatMessagesHistoryTtlResponse;
        case: 'setChatMessagesHistoryTtl';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetKeyPackagesForUntrustedDeviceResponse getKeyPackagesForUntrustedDevice = 120;
         */
        value: GetKeyPackagesForUntrustedDeviceResponse;
        case: 'getKeyPackagesForUntrustedDevice';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.CreateSecretChatAccessRequestResponse createSecretChatAccessRequest = 121;
         */
        value: CreateSecretChatAccessRequestResponse;
        case: 'createSecretChatAccessRequest';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetActiveSecretChatAccessRequestsResponse getActiveSecretChatAccessRequests = 122;
         */
        value: GetActiveSecretChatAccessRequestsResponse;
        case: 'getActiveSecretChatAccessRequests';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.AcceptSecretChatAccessRequestsResponse acceptSecretChatAccessRequests = 123;
         */
        value: AcceptSecretChatAccessRequestsResponse;
        case: 'acceptSecretChatAccessRequests';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.DeclineSecretChatAccessRequestsResponse declineSecretChatAccessRequests = 124;
         */
        value: DeclineSecretChatAccessRequestsResponse;
        case: 'declineSecretChatAccessRequests';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.CreateE2eeCommitResponse createE2eeCommit = 125;
         */
        value: CreateE2eeCommitResponse;
        case: 'createE2eeCommit';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ConsumeKeyPackagesByUserIdAndDeviceIdResponse consumeKeyPackagesByUserIdAndDeviceId = 126;
         */
        value: ConsumeKeyPackagesByUserIdAndDeviceIdResponse;
        case: 'consumeKeyPackagesByUserIdAndDeviceId';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.SetDeviceStatusResponse setDeviceStatus = 127;
         */
        value: SetDeviceStatusResponse;
        case: 'setDeviceStatus';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ClearCurrentDeviceE2eeDataResponse clearCurrentDeviceE2eeData = 128;
         */
        value: ClearCurrentDeviceE2eeDataResponse;
        case: 'clearCurrentDeviceE2eeData';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetKeyPackagesCountResponse getKeyPackagesCount = 129;
         */
        value: GetKeyPackagesCountResponse;
        case: 'getKeyPackagesCount';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.Response.
 * Use `create(ResponseSchema)` to create a new message.
 */
export const ResponseSchema: GenMessage<Response> = /*@__PURE__*/ messageDesc(file_websocket, 3);

/**
 * @generated from message com.gem.bff.contract.RealtimeEvent
 */
export type RealtimeEvent = Message<'com.gem.bff.contract.RealtimeEvent'> & {
  /**
   * @generated from oneof com.gem.bff.contract.RealtimeEvent.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.CallsActiveRealtimeEvent callsActive = 1;
         */
        value: CallsActiveRealtimeEvent;
        case: 'callsActive';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.CallSingleUpdateRealtimeEvent callSingleUpdate = 2;
         */
        value: CallSingleUpdateRealtimeEvent;
        case: 'callSingleUpdate';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.CallIncomingRealtimeEvent callIncoming = 3;
         */
        value: CallIncomingRealtimeEvent;
        case: 'callIncoming';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatsUpdateRealtimeEvent chatsUpdate = 4;
         */
        value: ChatsUpdateRealtimeEvent;
        case: 'chatsUpdate';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatSingleUpdateRealtimeEvent chatSingleUpdate = 5;
         */
        value: ChatSingleUpdateRealtimeEvent;
        case: 'chatSingleUpdate';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatStateChangedRealtimeEvent chatStateChanged = 6;
         */
        value: ChatStateChangedRealtimeEvent;
        case: 'chatStateChanged';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.UsersStatusUpdateRealtimeEvent usersStatusUpdate = 7;
         */
        value: UsersStatusUpdateRealtimeEvent;
        case: 'usersStatusUpdate';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.UserStatusSingleUpdateRealtimeEvent userStatusSingleUpdate = 8;
         */
        value: UserStatusSingleUpdateRealtimeEvent;
        case: 'userStatusSingleUpdate';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.PushNotificationRealtimeEvent pushNotification = 9;
         */
        value: PushNotificationRealtimeEvent;
        case: 'pushNotification';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.MessagesUpdateRealtimeEvent messagesUpdate = 10;
         */
        value: MessagesUpdateRealtimeEvent;
        case: 'messagesUpdate';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.MessageDeletedRealtimeEvent messageDeleted = 11;
         */
        value: MessageDeletedRealtimeEvent;
        case: 'messageDeleted';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.UserTypingMessageRealtimeEvent userTypingMessage = 12;
         */
        value: UserTypingMessageRealtimeEvent;
        case: 'userTypingMessage';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.MessageSentRealtimeEvent messageSent = 13;
         */
        value: MessageSentRealtimeEvent;
        case: 'messageSent';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.CalendarUpdateRealtimeEvent calendarEventUpdate = 14;
         */
        value: CalendarUpdateRealtimeEvent;
        case: 'calendarEventUpdate';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.SessionInvalidatedRealtimeEvent sessionInvalidated = 15;
         */
        value: SessionInvalidatedRealtimeEvent;
        case: 'sessionInvalidated';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.DeviceStatusUpdateEvent deviceStatusUpdate = 16;
         */
        value: DeviceStatusUpdateEvent;
        case: 'deviceStatusUpdate';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.RealtimeEvent.
 * Use `create(RealtimeEventSchema)` to create a new message.
 */
export const RealtimeEventSchema: GenMessage<RealtimeEvent> =
  /*@__PURE__*/
  messageDesc(file_websocket, 4);
